import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import api from "../services/api";
import { Link } from "react-router-dom";
import DashboardDesafiosDia from "../components/DashboardDesafiosDia";
import DashboardGrupos from "../components/DashboardGrupos";


export default function Dashboard() {
  const [data, setData] = useState(null);

  const [expandirTotal, setExpandirTotal] = useState(false);

  const loadDashboard = () => {
    api
      .get("/dashboard/")
      .then((res) => setData(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    loadDashboard();
  }, []);

  if (!data) {
    return (
      <>
        <Navbar />
        <div className="container mt-4">
          <p>Carregando...</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h2 className="mb-4">Bem-vindo(a),</h2>

        {/* PERFIL DO USUÁRIO */}
        <div className="accordion mb-4" id="accordionPerfil">
          <div className="accordion-item shadow-sm">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed d-flex align-items-center"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapsePerfil"
                aria-expanded="false"
                aria-controls="collapsePerfil"
                style={{
                  backgroundColor: "#233DFF",
                  color: "white",
                  fontWeight: "600",
                }}
              >
                <img
                  src={data.aluno.foto_perfil || `https://ui-avatars.com/api/?name=${encodeURIComponent(data.aluno.nome)}&size=55&background=6366f1&color=fff&bold=true`}
                  alt="Foto de perfil"
                  className="rounded-circle me-3"
                  width="55"
                  height="55"
                  style={{ objectFit: "cover", border: "2px solid white" }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(data.aluno.nome)}&size=55&background=6366f1&color=fff&bold=true`;
                  }}
                />

                <span style={{ fontSize: "1.2rem" }}>
                  {data.aluno.nome}
                </span>
              </button>
            </h2>

            <div
              id="collapsePerfil"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionPerfil"
            >
              <div className="accordion-body">
                <h5 className="fw-bold mb-3">Informações do Perfil</h5>

                <p className="mb-1">
                  <strong>E-mail:</strong> {data.aluno.email}
                </p>

                {data.aluno.telefone && (
                  <p className="mb-1">
                    <strong>Telefone:</strong> {data.aluno.telefone}
                  </p>
                )}

                {data.aluno.curso && (
                  <p className="mb-1">
                    <strong>Curso:</strong> {data.aluno.curso}
                  </p>
                )}

                {data.aluno.prova_prioritaria && (
                  <p className="mb-1">
                    <strong>Prova Prioritária:</strong>{" "}
                    {data.aluno.prova_prioritaria}
                  </p>
                )}

                {data.aluno.especialidade_pretendida && (
                  <p className="mb-1">
                    <strong>Especialidade Pretendida:</strong>{" "}
                    {data.aluno.especialidade_pretendida}
                  </p>
                )}

                {data.aluno.perfil && (
                  <p className="mb-1">
                    <strong>Perfil:</strong> {data.aluno.perfil}
                  </p>
                )}

                <p className="mb-1">
                  <strong>Percentual Alvo:</strong>{" "}
                  {data.aluno.percentual_alvo_acertos}%
                </p>

                <p className="mb-0">
                  <strong>Entrada:</strong>{" "}
                  {new Date(data.aluno.data_entrada).toLocaleDateString(
                    "pt-BR"
                  )}
                </p>

                <p className="mt-3 mb-3">
                  <Link
                    to="/me/editar"
                    className="btn btn-outline-primary btn-sm me-2"
                  >
                    Editar Perfil
                  </Link>

                  <a
                    href={`/perfil/${data.aluno_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-secondary btn-sm"
                  >
                    Compartilhar Perfil Público
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* PERFORMANCE */}
        <div className="card shadow-sm mb-4 p-3">
          <h5 className="fw-bold mb-3">Sua performance</h5>

          {/* Total de check-ins */}
          <p>
            Total de check-ins: <strong>{data.checkins.total}</strong>
            <br />

            <span style={{ fontSize: "1.8rem" }}>
              {expandirTotal
                ? data.checkins.emojis_total.join("")
                : data.checkins.emojis_total.slice(0, 50).join("")}
            </span>

            {data.checkins.emojis_total.length > 50 && (
              <button
                className="btn btn-link p-0 ms-2"
                onClick={() => setExpandirTotal(!expandirTotal)}
                style={{ fontSize: "0.9rem" }}
              >
                {expandirTotal
                  ? "ver menos"
                  : `+${data.checkins.emojis_total.length - 50} ver mais`}
              </button>
            )}
          </p>

          {/* Hoje */}
          <p>
            Hoje: <strong>{data.checkins.hoje}</strong>
            <br />
            <span style={{ fontSize: "1.8rem" }}>
              {data.checkins.emojis_hoje.join("")}
            </span>
          </p>

          {/* Semana */}
          <p>
            Semana: <strong>{data.checkins.semana}</strong>
            <br />
            <span style={{ fontSize: "1.8rem" }}>
              {data.checkins.emojis_semana.join("")}
            </span>
          </p>
        </div>

        {/* DESAFIOS DO DIA */}
        <div className="card shadow-sm mb-4 p-3">
          <h5 className="fw-bold mb-3">Desafios do dia</h5>

          {data.desafios.do_dia.length === 0 && (
            <p>Nenhum desafio hoje.</p>
          )}

          <div className="card shadow-sm mb-4 p-3">
            <DashboardDesafiosDia
              desafios={data.desafios.do_dia}
              onCheckinDone={loadDashboard}
            />
          </div>
        </div>

        {/* BADGES */}
        <div className="card shadow-sm mb-4 p-3">
          <h5 className="fw-bold mb-3">Badges conquistadas</h5>

          {data.badges.lista.length === 0 && <p>Nenhuma badge ainda.</p>}

          <div className="d-flex gap-2 flex-wrap">
            {data.badges.lista.map((badge, i) => (
              <span
                key={i}
                className="badge bg-primary"
                style={{ fontSize: "1rem" }}
              >
                {badge.emoji} {badge.nome}
              </span>
            ))}
          </div>
        </div>

        {/* GRUPOS */}
        <DashboardGrupos />
      </div>
    </>
  );
}
